import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`padding:2rem;`;
const Back = styled.button`margin-bottom:1rem;`;

const Terms: React.FC = () => {
  const nav = useNavigate();
  return (
    <Container>
      <Back onClick={() => nav('/dashboard')}>Back</Back>
      <h1>Terms & Conditions</h1>
      <p>Placeholder for terms and conditions.</p>
    </Container>
  );
};

export default Terms;
